import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  PHONE_CONFIGS,
  DEFAULT_PHONE_CONFIG,
  ZIP_CONFIGS,
  DEFAULT_ZIP_CONFIG,
} from '@app/utils/helpers/country-config.helper';
import { formatMask, formatValueAccordingToRegExp } from '@app/utils/helpers/phoneFormat.helpers';

@Injectable({
  providedIn: 'root',
})
export class CountryFormatService {
  public configurePhoneControl(
    control: FormControl,
    countryName: string,
    phoneRegex: RegExp | null,
  ): { mask: string; prefix: string } {
    if (!phoneRegex) {
      return { mask: '', prefix: '' };
    }

    const countryLower = countryName.toLowerCase();
    const config = PHONE_CONFIGS[countryLower];

    if (config) {
      control.setValidators([Validators.required, config.validator(phoneRegex, config.prefix)]);

      return { mask: config.mask, prefix: config.prefix };
    }

    control.setValidators([Validators.required, DEFAULT_PHONE_CONFIG.validator(phoneRegex, '')]);

    return {
      mask: formatMask(phoneRegex),
      prefix: DEFAULT_PHONE_CONFIG.prefix,
    };
  }

  public configureZipControl(
    control: FormControl,
    countryName: string,
    zipRegex: RegExp | null,
  ): { mask: string; prefix: string } {
    if (!zipRegex) {
      return { mask: '', prefix: '' };
    }

    const countryLower = countryName.toLowerCase();
    const config = ZIP_CONFIGS[countryLower];

    if (config) {
      control.setValidators([Validators.required, config.validator(zipRegex, config.prefix)]);

      return { mask: config.mask, prefix: config.prefix };
    }

    control.setValidators([Validators.required, DEFAULT_ZIP_CONFIG.validator(zipRegex, '')]);

    return {
      mask: formatMask(zipRegex),
      prefix: DEFAULT_ZIP_CONFIG.prefix,
    };
  }

  public formatPhoneForSubmit(
    phoneValue: string,
    countryName: string,
    phoneMask: string,
  ): string | null {
    const countryLower = countryName.toLowerCase();
    const config = PHONE_CONFIGS[countryLower];

    if (config?.formatValue) {
      phoneValue = config.formatValue(phoneValue, config.prefix);
    }

    const regex = new RegExp(phoneMask);
    return formatValueAccordingToRegExp(phoneValue, regex);
  }

  public parsePhoneFromServer(phoneValue: string, countryName: string): string {
    const countryLower = countryName.toLowerCase();
    const config = PHONE_CONFIGS[countryLower];

    if (config?.parseValue) {
      return config.parseValue(phoneValue, config.prefix);
    }

    return phoneValue;
  }

  public formatZipForSubmit(
    zipValue: string,
    countryName: string,
    zipMask?: string,
  ): string | null {
    const countryLower = countryName.toLowerCase();
    const config = ZIP_CONFIGS[countryLower];

    if (config?.formatValue) {
      return config.formatValue(zipValue, config.prefix);
    }

    if (zipMask) {
      const regex = new RegExp(zipMask);
      return formatValueAccordingToRegExp(zipValue, regex);
    }

    return zipValue;
  }

  public parseZipFromServer(zipValue: string, countryName: string): string {
    const countryLower = countryName.toLowerCase();
    const config = ZIP_CONFIGS[countryLower];

    if (config?.parseValue) {
      return config.parseValue(zipValue, config.prefix);
    }

    return zipValue;
  }
}
